$(document).ready(function() {
    $("#category").on("change", function() {
        var conceptName = $("#category")
            .find(":selected")
            .val();
        console.log(conceptName);
        if (conceptName == 99) {
            $("#other-option").show();
        } else {
            $("#other-option").hide();
        }
    });
});
